import * as React from "react"
import { FaUser } from "react-icons/fa"
import { gql } from "@apollo/client"
import { Avatar, Box, Button, Flex, Link, SimpleGrid, Stack, Text, Tooltip } from "@chakra-ui/react"
import NextLink from "next/link"

import { EventDetailFragment } from "lib/graphql"

const _ = gql`
  fragment EventAttendee on EventAttendee {
    id
    firstName
    avatarUrl
    privacySetting
  }
`

interface Props {
  event: EventDetailFragment
  onShowMore?: () => void
  count: number
}

export function EventAttendees({ event, count, onShowMore }: Props) {
  return (
    <Stack spacing={4} overflow="hidden" mt={24}>
      <Flex fontWeight="bold" justifyContent="space-between">
        {count > 0 && (
          <Text fontSize="xl">{`Attending (${count}${
            event.maxAttendees ? `/${event.maxAttendees}` : ""
          })`}</Text>
        )}
        {event.attendees.items.length < count && (
          <Button variant="ghost" onClick={onShowMore}>
            Alles zien
          </Button>
        )}
      </Flex>
      <SimpleGrid columns={{ base: 3, md: 5 }} spacing={1}>
        {event.attendees.items.map((attendee) => {
          return (
            <Tooltip
              key={attendee.id}
              label={attendee.firstName}
              bg="yellow.500"
              color="black"
              fontWeight="bold"
            >
              <Box mb={2} mr={2}>
                <Link as={NextLink} href={`/users/${attendee.id}`} passHref _hover={{ textDecor: "none" }}>
                  <Avatar
                    src={attendee.avatarUrl || undefined}
                    name={attendee.firstName || "avatar"}
                    w="65px"
                    h="65px"
                    bg="gray.600"
                    icon={<FaUser color="gray.900" size={18} />}
                    aria-label={`${attendee.firstName || "Deelnemer"} avatar`}
                  />
                </Link>
              </Box>
            </Tooltip>
          )
        })}
      </SimpleGrid>
    </Stack>
  )
}
